module.exports = __webpack_public_path__ + "static/media/mysql.b018dd4e.svg";